import { render, staticRenderFns } from "./power-manage.vue?vue&type=template&id=57d515ce&scoped=true&"
import script from "./power-manage.vue?vue&type=script&lang=js&"
export * from "./power-manage.vue?vue&type=script&lang=js&"
import style0 from "./power-manage.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./power-manage.vue?vue&type=style&index=1&id=57d515ce&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d515ce",
  null
  
)

export default component.exports